import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import Page from 'components/Page';

import Tabs from '@common/components/Tabs';
import { useServiceRouter } from '@common/components/ServiceRouter';
import createReportTabs from '@common/modules/Report/constants/tabs';

function ReportPage() {
	const { t } = useTranslation();
	const { checkService } = useServiceRouter();
	const reportTabs = useMemo(() => createReportTabs(t, { showAbout: !checkService('lyceum') }), [t, checkService]);
	return (
		<Page header={<Tabs isRoute tabs={reportTabs} />} type="list">
			<Outlet />
		</Page>
	);
}

export default ReportPage;
